// extracted by mini-css-extract-plugin
export default {"Code":"Code_Code__GiV7e"};